import React from "react";
import TaskCardContentsFirstSteps from "../../organisms/TaskCardContents/TaskCardFirstSteps";
import { TransportationType } from "../../../interface/transportation";
import TaskCardContentsSecondSteps from "../../organisms/TaskCardContents/TaskCardSecondSteps";
import TaskCardContentsThirdSteps from "../../organisms/TaskCardContents/TaskCardThirdSteps";
import TaskCardContentsFourSteps from "../../organisms/TaskCardContents/TaskCardFourSteps";
import TaskCardContentsFifthSteps from "../../organisms/TaskCardContents/TaskCardFifthSteps";
import TaskCardContentsFinalSteps from "../../organisms/TaskCardContents/TaskCardFinalSteps";

export interface TaskCardMainProps {
  ongoingDetailData: TransportationType;
  handleNextButtonClick: () => void;
  handleBackBtnClick: () => void;
  isNextLevel: any;
  setIsNextLevel: React.Dispatch<React.SetStateAction<number>>;
  setIsImgCheck: React.Dispatch<React.SetStateAction<boolean>>;
  setIsErrorCheck: React.Dispatch<React.SetStateAction<boolean>>;
  isImgCheck: boolean;
  isErrorCheck: boolean;
  onImageRegisterPageMove: () => void;
  onInvoiceImageRegisterPageMove: () => void;
}

/** 인턴 수정 페이지 컴포넌트 문제
 * $$ 수정 필요한 부분
 */
const TaskCardTemplates = ({
  ongoingDetailData,
  handleNextButtonClick,
  handleBackBtnClick,
  isNextLevel,
  setIsNextLevel,
  setIsImgCheck,
  setIsErrorCheck,
  isImgCheck,
  isErrorCheck,
  onImageRegisterPageMove,
  onInvoiceImageRegisterPageMove,
}: TaskCardMainProps) => {
  // work_place 값 확인
  const hasWorkPlace = ongoingDetailData?.transport_type === 1;

  return (
    <>
      {/* work_place가 존재할 때의 로직 */}
      {hasWorkPlace && isNextLevel <= 1 ? (
        <TaskCardContentsFirstSteps
          setIsNextLevel={setIsNextLevel}
          loadingPointData={ongoingDetailData || []}
          handleNextButtonClick={handleNextButtonClick}
          onImageRegisterPageMove={onImageRegisterPageMove}
        />
      ) : hasWorkPlace && isNextLevel === 2 ? (
        <TaskCardContentsSecondSteps
          loadingCompletedData={ongoingDetailData || []}
          handleNextButtonClick={handleNextButtonClick}
          handleBackBtnClick={handleBackBtnClick}
          setIsImgCheck={setIsImgCheck}
          setIsErrorCheck={setIsErrorCheck}
          isImgCheck={isImgCheck}
          isErrorCheck={isErrorCheck}
          onImageRegisterPageMove={onImageRegisterPageMove}
          isNextLevel={isNextLevel}
        />
      ) : hasWorkPlace && isNextLevel === 3 ? (
        <TaskCardContentsThirdSteps
          setIsNextLevel={setIsNextLevel}
          handleNextButtonClick={handleNextButtonClick}
          handleBackBtnClick={handleBackBtnClick}
          workPointData={ongoingDetailData || []}
          onImageRegisterPageMove={onImageRegisterPageMove}
          onInvoiceImageRegisterPageMove={onInvoiceImageRegisterPageMove}
        />
      ) : hasWorkPlace && isNextLevel === 4 ? (
        <TaskCardContentsFourSteps
          workCompletedData={ongoingDetailData || []}
          handleNextButtonClick={handleNextButtonClick}
          handleBackBtnClick={handleBackBtnClick}
          setIsNextLevel={setIsNextLevel}
          setIsImgCheck={setIsImgCheck}
          setIsErrorCheck={setIsErrorCheck}
          isImgCheck={isImgCheck}
          isErrorCheck={isErrorCheck}
          onImageRegisterPageMove={onImageRegisterPageMove}
          onInvoiceImageRegisterPageMove={onInvoiceImageRegisterPageMove}
        />
      ) : hasWorkPlace && isNextLevel === 5 ? (
        <TaskCardContentsFifthSteps
          setIsNextLevel={setIsNextLevel}
          unloadingPointData={ongoingDetailData || []}
          handleNextButtonClick={handleNextButtonClick}
          handleBackBtnClick={handleBackBtnClick}
          onImageRegisterPageMove={onImageRegisterPageMove}
          isErrorCheck={isErrorCheck}
        />
      ) : hasWorkPlace && isNextLevel >= 6 ? (
        <TaskCardContentsFinalSteps
          handleNextButtonClick={handleNextButtonClick}
          handleBackBtnClick={handleBackBtnClick}
          unloadingCompletedData={ongoingDetailData || []}
          setIsImgCheck={setIsImgCheck}
          setIsErrorCheck={setIsErrorCheck}
          setIsNextLevel={setIsNextLevel}
          onImageRegisterPageMove={onImageRegisterPageMove}
          isImgCheck={isImgCheck}
          isErrorCheck={isErrorCheck}
        />
      ) : null}

      {/* work_place가 없을 때의 로직 */}
      {!hasWorkPlace && isNextLevel <= 1 ? (
        <TaskCardContentsFirstSteps
          setIsNextLevel={setIsNextLevel}
          loadingPointData={ongoingDetailData || []}
          handleNextButtonClick={handleNextButtonClick}
          onImageRegisterPageMove={onImageRegisterPageMove}
          maxStep={4}
        />
      ) : !hasWorkPlace && isNextLevel === 2 ? (
        <TaskCardContentsSecondSteps
          loadingCompletedData={ongoingDetailData || []}
          handleNextButtonClick={handleNextButtonClick}
          handleBackBtnClick={handleBackBtnClick}
          setIsImgCheck={setIsImgCheck}
          setIsErrorCheck={setIsErrorCheck}
          isImgCheck={isImgCheck}
          isErrorCheck={isErrorCheck}
          onImageRegisterPageMove={onImageRegisterPageMove}
          isNextLevel={isNextLevel}
          maxStep={4}
        />
      ) : !hasWorkPlace && isNextLevel === 5 ? (
        <TaskCardContentsFifthSteps
          setIsNextLevel={setIsNextLevel}
          unloadingPointData={ongoingDetailData || []}
          handleNextButtonClick={handleNextButtonClick}
          handleBackBtnClick={handleBackBtnClick}
          onImageRegisterPageMove={onImageRegisterPageMove}
          onInvoiceImageRegisterPageMove={onInvoiceImageRegisterPageMove}
          isErrorCheck={isErrorCheck}
          maxStep={4}
          step={3}
        />
      ) : !hasWorkPlace && isNextLevel >= 6 ? (
        <TaskCardContentsFinalSteps
          handleNextButtonClick={handleNextButtonClick}
          handleBackBtnClick={handleBackBtnClick}
          unloadingCompletedData={ongoingDetailData || []}
          setIsImgCheck={setIsImgCheck}
          setIsErrorCheck={setIsErrorCheck}
          setIsNextLevel={setIsNextLevel}
          onImageRegisterPageMove={onImageRegisterPageMove}
          onInvoiceImageRegisterPageMove={onInvoiceImageRegisterPageMove}
          isImgCheck={isImgCheck}
          isErrorCheck={isErrorCheck}
          maxStep={4}
          step={4}
        />
      ) : null}
    </>
  );
};

export default TaskCardTemplates;
